import {AuthService} from 'core/services';
import {DI} from 'core/di-container';
import React, {useEffect, useState} from 'react';
import {Spinner} from 'react-bootstrap';
import {Navigate, useLocation} from 'react-router-dom';

const authService: AuthService = DI.get(AuthService);
type Props = { children: React.ReactElement, redirectLink: string };
type States = { loading: boolean, isAuth: boolean };
export const RequireAuth: React.FunctionComponent<Props> = ({children, redirectLink}) => {
    const location = useLocation();
    const [states, setStates] = useState({isAuth: false, loading: true} as States);

    useEffect(() => {
        authService.isAuthenticated().then((isAuth) => {
            setStates({...states, loading: false, isAuth});
        });
    }, [location]);

    if (states.loading) {
        return (
            <Spinner animation="border" variant="dark"
                     style={{position: 'absolute', left: 'calc(50% - 16px)', top: 'calc(50% - 16px)'}}/>
        );
    }

    if (!states.isAuth) {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        return <Navigate to={redirectLink} state={{from: location}} replace/>;
    }

    return children;
}
